/**
 * @generated SignedSource<<69adaaa975d3bb98285d89324cde2376>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment$data = {
  readonly __typename: "Content";
  readonly id: string | null | undefined;
  readonly status: string | null | undefined;
  readonly subType: string | null | undefined;
  readonly " $fragmentType": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment";
};
export type ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment$key = {
  readonly " $data"?: ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "ConfluenceSmartCardProviderConsolidatedSmartCardProviderReadFragment",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "id"
    },
    {
      "kind": "ScalarField",
      "name": "subType"
    },
    {
      "kind": "ScalarField",
      "name": "status"
    },
    {
      "kind": "ScalarField",
      "name": "__typename"
    }
  ],
  "type": "Content"
};

(node as any).hash = "3fd9bcac35b412a193a9c2f2d5df8b3c";

export default node;
